<span *ngIf="item.estatus_alumno">
    <span class="tag" [ngClass]="item.estatus_alumno.color">{{item.estatus_alumno.etiqueta}}</span>
</span>

<a class="navbar-item tooltip" routerLink="{{url_imprimir}}" *ngIf="ver">
    <span class="icon fa-2x  has-text-primary">
                <i class="icon-id-card"></i>
            </span>
    <span class="tooltiptext">Ver</span>
</a>

<a class="navbar-item tooltip" routerLink="{{url_editar}}" *ngIf="permisos.indexOf(controlador + '.update') > -1 || permisos.indexOf( 'Sis' + controlador + '.update') > -1">
    <span class="icon fa-2x  has-text-primary">
                <i class="icon-edit-1"></i>
            </span>
    <span class="tooltiptext">Editar</span>
</a>

<a class="navbar-item tooltip" [ngClass]="{'is-loading': ctrl.imprimir_cargando && ctrl.contador == index}" *ngIf="permisos.indexOf(controlador + '.show') > -1 || permisos.indexOf( 'Sis' + controlador + '.show') > -1" (click)="ctrl.imprimir(item, index)">
    <span class="icon fa-2x has-text-link">
                <i class="icon-printer2"></i>
            </span>
    <span class="tooltiptext">Imprimir</span>
</a>

<span class="icon fa-2x" *ngIf="item.cargando">
            <i class="fa fa-circle-o-notch fa-spin"></i>
        </span>

<a class="navbar-item tooltip" *ngIf="!item.cargando && (permisos.indexOf(controlador + '.devolucion') > -1 && (modulo == 'venta' || modulo == 'compra'))" routerLink="../devolucion/{{item.id}}">
    <span class="icon fa-2x  has-text-warning">
                <i class="fa fa-recycle"></i>
            </span>
    <span class="tooltiptext">Devolución</span>
</a>

<a class="navbar-item tooltip" *ngIf="!item.cargando && (permisos.indexOf(controlador + '.recibir') > -1 && (modulo == 'traspaso') && ctrl.configuracion.sucursal.id == item.sucursal_recibe)" routerLink="../recibir/{{item.id}}">
    <span class="icon fa-2x  has-text-link">
                <i class="fa fa-dropbox"></i>
            </span>
    <span class="tooltiptext">Recibir Traspaso</span>
</a>

<a class="navbar-item tooltip" *ngIf="!item.cargando && (permisos.indexOf(controlador + '.destroy') > -1 || permisos.indexOf( 'Sis' + controlador + '.destroy') > -1)" (click)="ctrl.eliminar(item, index)">
    <span class="icon fa-2x  has-text-danger">
                <i class="icon-trash"></i>
            </span>
    <span class="tooltiptext">Eliminar</span>
</a>